import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  background: #fefefe;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

const Input = styled.input`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  background: #28a745;
  color: white;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    background: #218838;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const MiejsceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 6px;
`;

export default function MiejscaGier({ rocznikId }) {
    const [miejsca, setMiejsca] = useState([]);
    const [formData, setFormData] = useState({ nazwa: "", adres: "" });
    const [loading, setLoading] = useState(false);
    // --- Pobierz miejsca gier ---
    const fetchMiejsca = async () => {
        if (!rocznikId) return;
        try {
            const res = await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/miejscaGier`);
            const data = await res.json();
            setMiejsca(data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchMiejsca();
    }, [rocznikId]);

    // --- Handle input change ---
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // --- Dodaj miejsce gry ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/miejscaGier`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });
            setFormData({ nazwa: "", adres: "" });
            fetchMiejsca();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // --- Usuń miejsce gry ---
    const handleDelete = async (index) => {
        if (!window.confirm("Na pewno chcesz usunąć to miejsce?")) return;
        try {
            await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/miejscaGier/${index}`, {
                method: "DELETE",
            });
            fetchMiejsca();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Container>
            <h3>Miejsca gier</h3>
            <Form onSubmit={handleSubmit}>
                <Input
                    name="nazwa"
                    placeholder="Nazwa miejsca"
                    value={formData.nazwa}
                    onChange={handleChange}
                    required
                />
                <Input
                    name="adres"
                    placeholder="Adres"
                    value={formData.adres}
                    onChange={handleChange}
                    required
                />
                <Button type="submit" disabled={loading}>Dodaj miejsce</Button>
            </Form>

            {miejsca.map((m, idx) => (
                <MiejsceItem key={idx}>
                    <div>{m.nazwa} – {m.adres}</div>
                    <Button
                        type="button"
                        style={{ background: "#dc3545" }}
                        onClick={() => handleDelete(idx)}
                    >
                        Usuń
                    </Button>
                </MiejsceItem>
            ))}
        </Container>
    );
}
